<template>
  <article ref="articleRef" :class="cardLayoutClasses" :data-product-id="productId">
    <section
      class="relative border rounded-md bg-white w-full overflow-hidden rounded-lg transition-all"
      :class="[
        inCart ? productCardInCartShadowClasses : cardShadowClasses,
        isHighlighted && 'ring-2 ring-red-500 ring-offset-2 animate-pulse'
      ]"
    >
      <slot></slot>
    </section>
  </article>
</template>

<script>
import { ref, inject } from 'vue'
import { cardShadowClasses, productCardInCartShadowClasses } from '@/config'
import { useProductCardLayout } from '@/composables/useProductCardLayout'
export default {
  name: 'ProductContainer',
  props: {
    inCart: { type: Boolean, required: true },
    productId: { type: [String, Number], default: null }
  },
  setup() {
    const articleRef = ref(null)
    const v1HighlightedProductId = inject('v1HighlightedProductId', ref(null))
    const { cardLayoutClasses } = useProductCardLayout()

    return {
      articleRef,
      cardLayoutClasses,
      cardShadowClasses,
      productCardInCartShadowClasses,
      v1HighlightedProductId
    }
  },
  computed: {
    isHighlighted() {
      return this.productId != null && String(this.v1HighlightedProductId) === String(this.productId)
    }
  }
}
</script>
